import { MessagePrimitive, useAttachment, useComposer, useMessage } from '@assistant-ui/react';
import { ComponentPropsWithoutRef, FC, forwardRef } from 'react';
import { MeAvatar } from '../../../../components/me-avatar';
import { withDefaults } from './utils/with-defaults';
import { UserMessageAttachments } from './attachment';
import { MarkdownText } from './markdown-text';

export const UserMessage: FC = () => {
    return (
        <UserMessageRoot>
            <div className="flex flex-row-reverse w-fit ml-auto text-primary-foreground max-w-[calc(var(--thread-max-width)*0.85)] break-words rounded-md gap-4">
                <UserMessageContent />
            </div>
        </UserMessageRoot>
    );
};

UserMessage.displayName = 'UserMessage';

const UserMessageAvatar: FC = () => {
    return <MeAvatar size="lg" className="avatar me-avatar" />;
};

const UserMessageRoot = withDefaults(MessagePrimitive.Root, {
    className:
        'aui-user-message-root grid group grid-cols-[1fr_auto_auto] grid-rows-[auto_1fr] max-w-[calc(var(--thread-max-width)*0.85)] w-full mt-2 justify-end',
});

UserMessageRoot.displayName = 'UserMessageRoot';

const UserMessageContentWrapper = withDefaults('div', {
    className:
        'aui-user-message-content flex flex-col gap-2 w-fit bg-background-brand-primary-subtle rounded-3xl px-5 py-2.5',
});

namespace UserMessageContent {
    export type Element = HTMLDivElement;
    export type Props = MessagePrimitive.Content.Props & ComponentPropsWithoutRef<'div'>;
}

const UserMessageContent = forwardRef<UserMessageContent.Element, UserMessageContent.Props>(
    ({ components: componentsProp, ...rest }, ref) => {
        return (
            <UserMessageContentWrapper {...rest} ref={ref}>
                <UserMessageAttachments />
                <MessagePrimitive.Content
                    components={{
                        ...componentsProp,
                        Text: componentsProp?.Text ?? MarkdownText,
                    }}
                />
            </UserMessageContentWrapper>
        );
    }
);

UserMessageContent.displayName = 'UserMessageContent';

const exports = {
    Root: UserMessageRoot,
    Avatar: UserMessageAvatar,
    Content: UserMessageContent,
};

export default Object.assign(UserMessage, exports) as typeof UserMessage & typeof exports;
